<template>
  <ul class="shareList">
    <li v-for="partner of partners" :key="partner.id">
      <div>
        <input type="checkbox" :id="partner.id" v-model="partner.active" :disabled='!partner.active && maxPartnerReached()' />
      </div>
      <label :for="partner.id">
        <strong>{{ partner.name }}</strong>
        <p>{{ partner.description }}</p>
        <p v-if="partner.id === 'SPW'" class="shareList-alert">{{ $t("survey.shareSPWAlert") }}</p>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ShareList',
  props: ['partners'],
  methods: {
    maxPartnerReached() {
      return this.partners.filter((p) => p.active).length >= 2;
    },
  },
};
</script>

<style>
.shareList li {
  display: flex;
  flex-direction: row;
  border: 5px solid #EEEEEE;
}
.shareList li div {
  width: 50px;
  display: flex;
  justify-content: center;
  background-color: #EEEEEE;
}
.shareList li div input {
  cursor: pointer;
  width: 18.5px;
}
.shareList p {
  margin: 0;
}
.shareList label {
  cursor: pointer;
  padding: 10px;
  width: 100%;
  user-select: none;
}
.shareList-alert {
  color: #c01935;;
}
</style>
